import React, { Component, Fragment } from 'react';
import LiveGuideDialog from '@com-pc/live-dropdown/live-guide-dialog';
import LiveInviteDialog from '@com-pc/live-dropdown/live-invite-dialog';
import Dropdown from '@com-pc/dropdown';
import { ILiveDropdownProps, ILiveDropdownService, ILiveDropdownState } from '@src/slide/application/service/live-dropdown-service/core/interface';
import ReactView from '@src/slide/infrastructure/module/independent/view-service-define/react/react-view';
import { LIVE_DROPDOWN_REF_NAME } from '@src/framework/frame-pc/components/live-dropdown/constants';
import AsyncBoundary from '@src/framework/frame/components/async-boundary';

/**
 * 远程演示下拉菜单
 * 目前 QQ 登录态下，点击"开始远程演示"会弹出菜单
 */
export default class LiveDropdown extends Component<ILiveDropdownProps, ILiveDropdownState> {
    private dropDom;
    private dropInvite;
    private liveDropdownService: ILiveDropdownService;

    public constructor(props) {
        super(props);
        props.getLiveDropdownService()?.setViewDelegate(new class extends ReactView<ILiveDropdownProps> {
            public getElementById(id: string) {
                return (this.realView as LiveDropdown)?.getRefById(id);
            }
        }(this));
        this.liveDropdownService = props.getLiveDropdownService();
    }

    public componentDidMount(): void {
        this.liveDropdownService.componentDidMount();
    }

    public render() {
        return (
            <Fragment>
                <Dropdown belongID={'live-show-btn'}
                    ref={(ref) => {
                        this.dropDom = ref;
                    }}
                    scrollable={false}
                    center="center"
                    hasShadow={false}
                    offsetX={14}
                    offsetY={5}
                    isTransparent={true}
                    zIndex={'var(--z-index-modal-negative)'}
                    onVisibleChange={() => {}}
                >
                    <LiveGuideDialog
                        handleOpenDocLive={this.liveDropdownService.handleOpenDocLive}
                        handleCloseLiveGuideDialog={this.liveDropdownService.handleCloseLiveGuideDialog}
                        {...this.state} />
                </Dropdown>
                <AsyncBoundary>
                    {
                        async () => {
                            const liveManager = await this.liveDropdownService.getLiveManager().promise();
                            return (
                                <Dropdown belongID={'live-invite-btn'}
                                    ref={(ref) => {
                                        this.dropInvite = ref;
                                    }}
                                    scrollable={false}
                                    center="center"
                                    hasShadow={false}
                                    offsetX={14}
                                    offsetY={5}
                                    isTransparent={true}
                                    zIndex={'var(--z-index-modal-negative)'}
                                    onVisibleChange={() => {}}
                                >
                                    <LiveInviteDialog
                                        handleCloseDialog={this.liveDropdownService.handleCloseLiveInviteDialog}
                                        liveManager={liveManager}
                                        showArrow={false}
                                        {...this.state} />
                                </Dropdown>
                            );
                        }
                    }
                </AsyncBoundary>


            </Fragment>
        );
    }

    public getRefById(id: string) {
        switch (id) {
            case LIVE_DROPDOWN_REF_NAME.DROP_DOM:
                return this.dropDom;
            case LIVE_DROPDOWN_REF_NAME.DROP_INVITE:
                return this.dropInvite;
        }
    }
}
